import React, { ReactComponentElement } from 'react';

import { Flex, Input, InputWrapperProps } from '@mantine/core';

import { MeasurementInput } from './MeasurementInput';

export type MeasurementInputWrapperProps = {
    emptySpacesBefore?: number;
    emptySpacesAfter?: number;
    placeholder?: string;
} & InputWrapperProps;

type MeasurementInputWrapperPropsWithChildren = MeasurementInputWrapperProps & {
    children: ReactComponentElement<typeof MeasurementInput>[] | ReactComponentElement<typeof MeasurementInput>;
};

const MeasurementInputWrapper = ({
    children,
    emptySpacesBefore = 0,
    emptySpacesAfter = 0,
    placeholder: _placeholder,
    ...props
}: MeasurementInputWrapperPropsWithChildren) => (
    <Input.Wrapper {...props}>
        <Flex gap={4}>
            {emptySpacesBefore > 0 && <div style={{ flex: emptySpacesBefore }} />}
            {React.Children.map(children, (child) => (
                <div style={{ flex: 1 }}>{child}</div>
            ))}
            {emptySpacesAfter > 0 && <div style={{ flex: emptySpacesAfter }} />}
        </Flex>
    </Input.Wrapper>
);

export { MeasurementInputWrapper };
